module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ibox"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "ibox-results-filters-collapse-box collapse in"
  }, [_c('div', {
    staticClass: "ibox-results-filters"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-lg-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Keyword")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Location Name or Keyword"
    },
    on: {
      "input": _vm.updateKeywords
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-lg-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Order")]), _vm._v(" "), _c('selectize', {
    staticClass: "select2-material-placeholder-search",
    attrs: {
      "placeholder": "- Select -",
      "options": _vm.orderOptions,
      "name": "order"
    },
    on: {
      "input": _vm.updateOrder
    }
  })], 1)])])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "ibox-content"
  }, [_c('ul', {
    staticClass: "list-detail list-detail-public-job"
  }, _vm._l((_vm.jobsDecorated), function(job) {
    return _c('job-board-list-item', {
      key: job.id,
      attrs: {
        "job": job
      }
    })
  })), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.haveNoJobs),
      expression: "haveNoJobs"
    }],
    staticClass: "text-center text-muted"
  }, [_c('strong', [_vm._v("There are no jobs.")])])]), _vm._v(" "), _c('lazy-loading', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.haveJobs),
      expression: "haveJobs"
    }],
    ref: "lazyLoading",
    attrs: {
      "reached-bottom": _vm.getJobBoardItemsForNextPage,
      "filters": _vm.filters
    }
  }, [_c('strong', {
    staticClass: "text-muted",
    slot: "finished"
  }, [_vm._v("There are no more jobs.")])]), _vm._v(" "), _c('job-board-modal')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "ibox-results-collapse visible-xs",
    attrs: {
      "role": "button",
      "data-toggle": "collapse",
      "href": ".ibox-results-filters-collapse-box",
      "aria-expanded": "false",
      "aria-controls": "ibox-results-filters-collapse-box"
    }
  }, [_vm._v("\n\t\t\t\tShow Filters "), _c('i', {
    staticClass: "fa fa-bars"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ibox-results-filters"
  }, [_c('p', {
    staticClass: "no-margin"
  }, [_vm._v("Please contact Arrow Logistics for more details on current jobs available:")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-efbc75a0"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/jobs/JobBoard.vue
// module id = 1086
// module chunks = 0